import GamesSoundControl from '../GamesSoundControl';
import { GameVideoLayoutProps } from './props';
import useTranslation from 'next-translate/useTranslation';
import { platformAssets } from '@/utils/assets';
import games from '@/constants/games';
import styles from './styles.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import { handleGameSound } from './helper';
import { useEffect } from 'react';
import { AudioService } from '@/services/AudioService';
import GameLayoutRender from './Render';
import { GameTagFilter } from '@/models/games/game-tag-filter.enum';
import { NavigationBreadcrumbs } from '@starsoft/common/components';
import SlotsGameContentGameDetails from '@/components/Slots/SlotsGame/Content/GameDetails';
import ProvidersSection from '@/components/Home/V2/ProvidersSection';
import OriginalsSection from '@/components/Home/Sections/GamesBaseSection/Originals';
import { GameID } from '@/enums/gameId';

export default function GameLayout({
  gameId,
  action,
  panel,
  board,
  error,
  useColumnLayout,
  refetch,
  useGridLayout,
}: GameVideoLayoutProps) {
  const { t } = useTranslation('common');
  const game = games.get(gameId.toString());
  const sound: boolean = useSelector(
    (state: RootState) => state.gamesAudio.sound,
  );

  function backgroundSoundGame() {
    handleGameSound(sound, gameId);

    return () => {
      AudioService.removeAudios();
    };
  }

  useEffect(backgroundSoundGame, [sound, gameId]);

  return (
    <div className={styles.container}>
      <div
        className={`${styles.container__row} ${styles['container__row--between']}`}
      >
        <NavigationBreadcrumbs
          to={`/games/tag/${GameTagFilter.Originals}`}
          lastPageLabel={
            t('betblex_originals_side', {
              provider: platformAssets.app,
            }) as string
          }
          currentPageLabel={game?.name as string}
        />

        <div
          className={`${styles.container__row} ${styles['container__row--small']}`}
        >
          {action}
          <GamesSoundControl />
        </div>
      </div>
      <GameLayoutRender
        error={error}
        panel={panel}
        board={board}
        useGridLayout={useGridLayout}
        useColumnLayout={useColumnLayout}
        refetch={refetch}
      />
      <SlotsGameContentGameDetails />
      {![GameID.Crash, GameID.CrashTrenball].includes(gameId) && (
        <>
          <OriginalsSection />
          <ProvidersSection />
        </>
      )}
    </div>
  );
}
